import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withStyles } from '@material-ui/core/styles';
import { Route, Switch, NavLink, Redirect, withRouter } from 'react-router-dom';

import styles from './styles';
import JobsTabContent from '../JobsContent';
import { JOB_STATUS_CODES } from '../../constants';
import { selectJobsCount } from '../../store/selectors';

const propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  jobsCount: PropTypes.shape({
    [JOB_STATUS_CODES.STATUS_01]: PropTypes.number.isRequired,
    [JOB_STATUS_CODES.STATUS_02]: PropTypes.number.isRequired,
    [JOB_STATUS_CODES.STATUS_03]: PropTypes.number.isRequired,
    [JOB_STATUS_CODES.STATUS_04]: PropTypes.number.isRequired,
  }).isRequired,
};

export const JobsContainer = props => {
  const { classes, location } = props;

  if (location.pathname === '/my-jobs') {
    // Redirect to all jobs by default
    return <Redirect to="/my-jobs/all-jobs" />;
  }

  return (
    <div className={classes.root}>
      <div className={classes.innerWrapper}>
        <div className={classes.headerWrapper}>
          <h1 className={classes.heading}>Jobs</h1>
        </div>
      </div>
      <div className={classes.innerWrapper}>
        <ul className={classes.nav}>
          <li>
            <NavLink
              activeClassName={classes.activeLink}
              to="/my-jobs/all-jobs"
            >
              All Jobs
            </NavLink>
          </li>
        </ul>
      </div>
      <Switch>
        <Route path="/my-jobs/all-jobs" component={JobsTabContent} />
      </Switch>
    </div>
  );
};

JobsContainer.propTypes = propTypes;

const mapStateToProps = createStructuredSelector({
  jobsCount: selectJobsCount(),
});

export default withRouter(
  withStyles(styles)(connect(mapStateToProps)(JobsContainer)),
);
